import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset scroll on route change - both window and any scrollable containers
    window.scrollTo(0, 0);
    
    // Also reset any main content containers
    const mainContent = document.querySelector('main');
    if (mainContent) {
      mainContent.scrollTop = 0;
    }
    
    // Reset scroll-area containers
    const scrollAreas = document.querySelectorAll('[data-radix-scroll-area-viewport]');
    scrollAreas.forEach(area => {
      (area as HTMLElement).scrollTop = 0;
    });
  }, [pathname]);

  return null;
};
